export const redirectToPlayApp = (): void => {
  const mainAppUrl = import.meta.env.VITE_MAIN_SITE_URL

  if (!mainAppUrl) {
    throw new Error('VITE_MAIN_SITE_URL not configured')
  }

  window.location.replace(mainAppUrl)
}